import * as React from 'react';
import { observer } from 'mobx-react';
import { DisplayType } from '../Models/Enums';
import classNames from 'classnames';
import * as uuid from 'uuid';
import { Tooltip } from '../Tooltip/Tooltip';

export enum CheckboxAlignment {
	VERTICAL = 'checkbox-group--vertical',
	HORIZONTAL = 'checkbox-group--horizontal',
}

export interface ICheckboxGroupProps {
	id?: string;
	className?: string;
	alignment?: CheckboxAlignment;
	displayType?: DisplayType;
	label?: React.ReactNode;
	tooltip?: string;
	innerProps?: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;
	children: React.ReactNode;
}

export const CheckboxGroup = observer(
	class CheckboxGroup extends React.Component<ICheckboxGroupProps, any> {
		private uuid = uuid.v4();

		public render() {
			const {
				innerProps = {},
				children,
				id = this.uuid.toString(),
				className,
				displayType,
				label,
				tooltip,
			} = this.props;

			const tooltipId = `${id}-tooltip`;
			const labelNode = label ? (
				<p className="input-group__checkbox-header" aria-describedby={tooltip ? tooltipId : undefined}>
					{label}
				</p>
			) : null;
			const tooltipNode = label && tooltip ? <Tooltip id={tooltipId} content={tooltip} /> : '';
			const classes = classNames(
				'input-group-wrapper__checkbox',
				className,
				innerProps.className,
				`input-group-${displayType ?? DisplayType.BLOCK}`,
			);

			return (
				<div id={id} className={classes} {...innerProps} aria-live="assertive">
					{labelNode}
					{tooltipNode}
					{children}
				</div>
			);
		}
	},
);
